import React from 'react'

function Spinner1() {
  return (
    <div id="cover-spin"></div>
  )
}

export default Spinner1